<template>
  <div class="wrapper">
    <div class="popup-container row">
      <div class="position-relative form-group col-12">
        <span>ID:&nbsp;</span>
        <span class="select-all">{{ data.id }}</span>
      </div>
      <div class="position-relative form-group col-12">
        <label class="col-12 mb-0 p-0">Shop Name*</label>
        <input class="form-control mt-2" type="text" name="name" :value="data.name" @change.stop.prevent="store.commit('name', $event.target.value)" />
      </div>
      <div class="position-relative form-group col-12 pl-0 pr-0 mb-0">
        <label class="col-12">Connect by</label>
        <div class="col-12 mb-3">
          <Select :options="more.connections" :value="data.connections" @changeValue="store.commit('connections', $event)" multiple></Select>
        </div>
      </div>
      <div v-show="Object.values(data.connections || []).indexOf('remote') != -1" class="position-relative form-group col-12">
        <div class="position-relative form-group col-12 pb-2 pt-2 mb-2 boder-dashed">
          <label class="mb-0">Token</label>
          <button type="submit" class="btn btn-primary ml-2 pt-0 pb-0" @click.stop.prevent="getAccountToken">Get</button>
          <button type="submit" class="btn btn-light ml-2 pt-0 pb-0" @click.stop.prevent="revokeAccountToken">Revoke</button>
          <p class="select-all mb-0 mt-2">{{ integration?.remote?.account_token }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  components: {
    //
  },
  data() {
    return {
      accountToken: null
    }
  },
  computed: {
    action() {
      return this.config?.action
    },
    storeId() {
      return this.config?.storeId
    },
    accountId() {
      return this.config?.accountId
    },
    extraUri() {
      return `sale-account/extra/${this.accountId}`
    },
    submitUri() {
      return `sale-account/update/${this.accountId}`
    },
    data() {
      return this.store.getter('', {})
    },
    meta() {
      return this.data.meta || {}
    },
    integration() {
      return _.mergeLeft(
        {
          remote: {
            account_token: ''
          }
        },
        this.data.integration || {}
      )
    },
    more() {
      return this.data.more || {}
    }
  },
  mounted() {
    this.$emitter.on('Modal.SaleAccount.Edit.Submit', this.submit)
  },
  unmounted() {
    this.$emitter.off('Modal.SaleAccount.Edit.Submit', this.submit)
  },
  methods: {
    getAccountToken(e) {
      let data = Object.assign(this.store.getter(''), {
        action: 'get-account-token',
        connection: 'remote'
      })

      this.$util.post(this.extraUri, data, e.target, {
        done: ({ status, account_token }) => {
          if (status == 'success') {
            this.store.commit('integration.remote.account_token', account_token)
          }
        }
      })
    },
    revokeAccountToken(e) {
      let data = Object.assign(this.store.getter(''), {
        action: 'revoke-account-token',
        connection: 'remote'
      })

      this.$util.post(this.extraUri, data, e.target, {
        done: ({ status }) => {
          if (status == 'success') this.store.commit('integration.remote.account_token', null)
        }
      })
    },
    submit(data) {
      this.submitForm(data, {
        done: () => {
          this.$emitter.emit('TableList.Refresh')
          this.$emit('close')
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
